import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Tilelet } from "@vds/tiles";
import { Body, Title } from "@vds/typography";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./GettingStartedModal.scss";

function GettingStartedModal() {
  const navigate = useNavigate();
  const loading = useSelector((state) => state.sitesReducer.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const siteTagList = useSelector((state) => state.sitesReducer.siteTagList);

  useEffect(() => {
    if (!loading && siteTagList) {
      if (Array.isArray(siteTagList.sites) && siteTagList.sites.length === 0) {
        setIsModalVisible(true);
      } else {
        setIsModalVisible(false);
      }
    }
  }, [loading, siteTagList]);

  return (
    <>
      <Modal
        opened={isModalVisible}
        // width={sites?.length === 0 && users.length === 0 ? "825px" : "525px"}
        width={"525px"}
        surface="light"
        style={{ backgroundColor: "#ffffff" }}
        zIndex={99}
        disableOutsideClick={true}
        closeButtonId="getting_started_close-btn"
      >
        <ModalTitle>
          <Title size="medium" bold={true}>
            Getting started
          </Title>
        </ModalTitle>
        <ModalBody>
          <Body size="large">Welcome to 5G Video Insights! Get started by adding some sites or users to the portal.</Body>
        </ModalBody>
        <div
          style={{
            maxWidth: "729px",
            maxHeight: "216px",
            width: "100%",
            height: "auto",
            display: "flex",
            flexDirection: "row",
            gap: "32px",
            marginTop: "40px",
            overflow: "hidden"
          }}
        >
          <Tilelet
            viewport="desktop"
            textAlignment="left"
            innerPadding="12px"
            eyebrow={{
              children: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "15px"
                  }}
                >
                  <Icon name="location" color={"#000000"} size="large" />
                  <Title size="small" bold={true}>
                    Add site
                  </Title>
                </div>
              )
            }}
            subtitle={{
              size: "bodyMedium",
              children: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    gap: "15px"
                  }}
                >
                  <Body size="large">Add a site to your organization.*</Body>
                  <Body size="small" viewport="desktop">
                    You will need floor plans in either JPG or PNG format.
                  </Body>
                </div>
              ),
              color: "primary"
            }}
            directionalIcon={{
              name: "right-caret",
              size: "small"
            }}
            surface="light"
            width="100%"
            height="216px"
            data-testid="dashboard_navigateToAddSite"
            onClick={() => navigate("/AddSite")}
            backgroundColor="gray"
          />
          {/* {users?.length === 0 && (
            <Tilelet
              viewport="desktop"
              textAlignment="left"
              innerPadding="12px"
              eyebrow={{
                children: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Icon name="user" color={"#000000"} size="large" />
                    <Title size="small" bold={true}>
                      Add user
                    </Title>
                  </div>
                ),
              }}
              title={{
                bold: true,
                size: "titleSmall",
                children: (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  ></div>
                ),
              }}
              subtitle={{
                size: "bodyLarge",
                children: "Invite a new user to join the portal",
                color: "primary",
              }}
              directionalIcon={{
                name: "right-caret",
                size: "small",
              }}
              surface="light"
              width="100%"
              height="216px"
              onClick={handleAddUserClick}
              backgroundColor="gray"
            />
          )} */}
        </div>
      </Modal>
    </>
  );
}

export default GettingStartedModal;
